import { connect } from "react-redux";
import { ItemUpdateHistory } from "../shared/ItemUpdateHistory";
import { getItemUpdateTasks, getStockRecounts, downloadStockRecountReceipt } from "../../app/store/actions/imsAdminActions";

const AdminItemUpdateHistory = (props) => (
    <ItemUpdateHistory
        {...props}
        progressBase="/ims/admin/item-updates"
        recountProgressBase="/ims/admin/stock-recount/progress"
        homePath="/ims/admin"
    />
);

const mapStateToProps = (state) => ({
    isLoading: state?.records?.isLoading,
    itemUpdateTasks: state?.records?.itemUpdateTasks,
    stockRecounts: state?.records?.stockRecounts,
});

export default connect(mapStateToProps, { getItemUpdateTasks, getStockRecounts, downloadStockRecountReceipt })(AdminItemUpdateHistory);
